import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, map } from "rxjs";
import { ConvivaApi } from "src/app/conviva-api";
import { ListarAtendimentos } from "../models/chamados/atendimentos-realizados";
import { AtendimentoPsicologos } from "../models/chamados/listar-atendimentos-psicologos";
import { ListarEncaminhados } from "../models/chamados/listar-encaminhados";
import { DefaultResponse } from "../models/DefaultResponse";
import { AprovacaoDiretorAtividadePOC, AprovacaoPECAtividadePOC } from "../models/professor/AprovacaoAtividadePOC";
import { SetUpdateAtividadePOCCommand } from "../models/professor/UpdateArquivosPOC";
import { VisitaPOC } from "../models/professor/VisitaPOC";
import { AgendamentoAtividadePrevencao } from "../models/psicologo/AgendamentoAtividadePrevencao";
import { AprovacaoPsicologoFiscal } from "../models/psicologo/AprovacaoPsicologoFiscal";
import { Atividade, AtividadePsicologo } from "../models/psicologo/AtividadePsicologo";
import { AtividadePsicologoOutros } from "../models/psicologo/AtividadePsicologoOutros";
import { CriacaoAgendamento } from "../models/psicologo/CriacaoAgedamento";
import { EditarJornadaAtividade } from "../models/psicologo/EditarJornadaAtividade";
import { ExclusaoAgendamento } from "../models/psicologo/ExclusaoAgendamento";
import { FinalizaJornadaOutroDia, JornadaJustificativaDistancia, JornadaJustificativaEntradaSaida, JornadaJustificativaTempoRegistro } from "../models/psicologo/JornadaJustificativaEntradaSaida";
import { AjustarJornada, FimJornada, InicioJornada, JornadaPsicologosInserir } from "../models/psicologo/JornadaPsicologo";
import { Psicologo } from "../models/psicologo/Psicologo";
import { RegistroAtividadePsicologoCheckOut } from "../models/psicologo/RegistroAtividadePsicologoCheckOut";
import { SetUpdateAtividadePsicologoCommand } from "../models/psicologo/UpdateArquivosPsicologo";
import { VisitaPsicologo } from "../models/psicologo/VisitaPsicologo";
import { Consolidado } from "../models/relatorio/Consolidado";
import { UpdateJornadaCoordenador } from "../models/psicologo/UpdateJornadaCoordenador";


@Injectable({
  providedIn: 'root'
})

export class PsicologoService {
  private api = ConvivaApi;

  constructor(
    private http: HttpClient,
    private router: Router) { }

  private normalizarCpf(cpf?: string | null): string | null {
    if (cpf == null) {
      return null;
    }
    const apenasDigitos = String(cpf).replace(/\D/g, '');
    if (apenasDigitos.length === 0) {
      return null;
    }
    return apenasDigitos.padStart(11, '0');
  }

  public getPolos(codigoDiretoria?: number | number[]): Observable<DefaultResponse> {
    let params = '';
    if (Array.isArray(codigoDiretoria)) {
      params = codigoDiretoria.join('&codigoDiretoria=');
    } else if (typeof codigoDiretoria === 'number') {
      params = codigoDiretoria.toString();
    }

    return this.http.get<DefaultResponse>(`${this.api.Psicologo.getPolos}?codigoDiretoria=${params}`)
      .pipe(map((response: DefaultResponse) => response));
  }
  public getPoloPsicologo(cpf: string): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.Psicologo.getPoloPsicologo}?cpf=${cpf}`)
      .pipe(map((response: DefaultResponse) => response));
  }
  public getDiretoriaEscolasPorPolo(codigoPolo: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.Psicologo.getDiretoriaEscolasPorPolo}?codigoPolo=${codigoPolo}`)
      .pipe(map((response: DefaultResponse) => response));
  }
  public getDiretoriaPorPolo(codigoPolo: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.Psicologo.getDiretoriasPorPolo}?codigoPolo=${codigoPolo}`)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setCadastrarPsicologo(parametros: Psicologo): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Psicologo.setCadastrarPsicologo}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setDeletarPsicologo(codigoPsicologo: number): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Psicologo.setDeletarPsicologo}?codigoPsicologo=${codigoPsicologo}`, codigoPsicologo)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setEditarPsicologo(parametros: Psicologo): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Psicologo.setEditarPsicologo}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getPsicologoPorCPF(cpf: string): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.Psicologo.getPsicologoPorCPF}?cpf=${cpf}`)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getPsicologoAtribuicoesPorCpf(cpf: string): Observable<DefaultResponse> {
    const cpfNormalizado = this.normalizarCpf(cpf);
    return this.http.get<DefaultResponse>(`${this.api.Psicologo.getPsicologoAtribuicoesPorCpf}?cpf=${cpfNormalizado}`)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getEncaminhamentos(parametros: ListarEncaminhados): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.getEncaminhamentos, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }
  public getPsicologosPorPolo(poloId: number) {
    return this.http.get<DefaultResponse>(`${this.api.Psicologo.getPsicologosPorPolo}?PoloId=${poloId}`)
      .pipe(map((response: DefaultResponse) => response));
  }
  public getCoordenadorPsicologosPorDiretoria(diretoriaId: number) {
    return this.http.get<DefaultResponse>(
      `${this.api.Psicologo.getCoordenadorPsicologosPorDiretoria}?DiretoriaId=${diretoriaId}`
    ).pipe(map((response: DefaultResponse) => response));
  }
  public postAgendarConsulta(agendamento: CriacaoAgendamento) {
    agendamento.cpfPsicologo = this.normalizarCpf(agendamento.cpfPsicologo) ?? agendamento.cpfPsicologo;
    if (agendamento.cpfCoordenador !== "0") {
      agendamento.cpfCoordenador = this.normalizarCpf(agendamento.cpfCoordenador) ?? agendamento.cpfCoordenador;
    }
    return this.http.post<DefaultResponse>(this.api.Psicologo.postSetAgendarConsulta, agendamento)
      .pipe(map((response: DefaultResponse) => response));
  }
  public postExcluirAgendamento(dadosAgendamento: ExclusaoAgendamento) {
    return this.http.post<DefaultResponse>(this.api.Psicologo.postSetExcluirAgendamento, dadosAgendamento)
      .pipe(map((response: DefaultResponse) => response));
  }
  public getPsicologoPorCodigo(codigoPsicologo: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.Psicologo.getPsicologoPorCodigo}?codigoPsicologo=${codigoPsicologo}`)
      .pipe(map((response: DefaultResponse) => response));
  }
  public getAtendimentoPsicologos(parametros: AtendimentoPsicologos): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.getAtendimentoPsicologo, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }
  public getPrazoAtendimentos(parametros: ListarAtendimentos): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.getPrazoAtendimentos, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setCadastrarVisitaPsicologo(parametros: VisitaPsicologo): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.setCadastrarVisitaPsicologo, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setUpdateAtividadePsicologo(parametros: SetUpdateAtividadePsicologoCommand): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.setUpdatePsicologo, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getVisitasPsicologo(parametros: Consolidado): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.getVisitasPsicologo, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setEditarVisitaPsicologo(parametros: VisitaPsicologo): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.setEditarVisitaPsicologo, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }
  public getDashboardAtividadePsicologos(parametros: Atividade): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.getDashboardAtividadePsicologo, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }
  public setExcluirAtividadePsicologo(codigoAtividadePsicologo: number): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.setExcluirAtividadePsicologo, { codigoAtividadePsicologo: codigoAtividadePsicologo })
      .pipe(map((response: DefaultResponse) => response));
  }
  public getDashboardAtividadePOCs(parametros: Atividade): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.getDashboardAtividadePOC, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getDashboardAtividadePsicologosFiscal(parametros: Atividade): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.getDashboardAtividadePsicologoFiscal, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setExcluirAtividadePOC(codigoAtividadePOC: number): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.setExcluirAtividadePOC, { codigoAtividadePOC: codigoAtividadePOC })
      .pipe(map((response: DefaultResponse) => response));
  }

  public getTurmasAprovacaoPOC(idAtividade: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.Psicologo.getTurmasAprovacaoPOC}?idAtividade=${idAtividade}`)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getTurmasAprovacaoPsicologo(idAtividade: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.Psicologo.getTurmasAprovacaoPsicologo}?idAtividade=${idAtividade}`)
      .pipe(map((response: DefaultResponse) => response));
  }

  public aprovacaoPECAtividadePOC(parametros: AprovacaoPECAtividadePOC): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.aprovacaoPECAtividadePOC, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public aprovacaoDiretorAtividadePOC(parametros: AprovacaoDiretorAtividadePOC): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.aprovacaoDiretorAtividadePOC, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  // public aprovacaoAtividadePsicologoPEC(parametros : AprovacaoPsicologoPEC):Observable<DefaultResponse>{
  //   return this.http.post<DefaultResponse>(this.api.Psicologo.aprovacaoAtividadePsicologoPEC, parametros )
  //                   .pipe(map((response:DefaultResponse) => response));
  // }

  public aprovacaoAtividadePsicologoFiscal(parametros: AprovacaoPsicologoFiscal): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.aprovacaoAtividadePsicologoFiscal, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setCadastrarAtividadePsicologoOutros(parametros: AtividadePsicologoOutros): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.setCadastrarAtividadePsicologoOutros, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getAvaliacaoFiscal(codigoPolo: number, codigoPsicologo: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.Psicologo.getAvaliacaoFiscal}?codigoPolo=${codigoPolo}&codigoPsicologo=${codigoPsicologo}`)
      .pipe(map((response: DefaultResponse) => response));
  }

  //POC

  public setCadastrarVisitaPOC(parametros: VisitaPOC): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.setCadastrarVisitaPOC, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setCadastrarAtividadePsicologo(parametros: AtividadePsicologo): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.setCadastrarAtividadePsicologo, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }
  public setCadastrarAgendamentoAtividadePrevencao(parametros: AgendamentoAtividadePrevencao): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.setCadastrarAgendamentoAtividadePrevencao, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setUpdateAtividadePOC(parametros: SetUpdateAtividadePOCCommand): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.setUpdatePOC, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getDatasAgendamentosPrevencao(codigoEscola: number, codigoDiretoria: number, mes: number, ano: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.Psicologo.getDatasAgendamentosPrevencao, { params: { codigoEscola: codigoEscola, codigoDiretoria: codigoDiretoria, mes: mes, ano: ano } })
      .pipe(map((response: DefaultResponse) => response));
  }

  public getAgendamentosPrevencao(codigoEscola: number, codigoDiretoria: number, codigoPsicologo: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.Psicologo.getAgendamentosPrevencao, {
      params: { codigoEscola: codigoEscola, codigoDiretoria: codigoDiretoria, codigoPsicologo: codigoPsicologo }
    })
      .pipe(map((response: DefaultResponse) => response));
  }
  public getAgendamentosPrevencaoPorId(codigoAgendamento: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.Psicologo.getAgendamentoPrevencaoPorId, { params: { codigoAgendamento } })
      .pipe(map((response: DefaultResponse) => response));
  }



  public setAutorizacaoUsoDados(body: any): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.setAutorizacaoUsoDados, body)
      .pipe(map((response: DefaultResponse) => response));
  }

  public registraInicioJornada(body: InicioJornada): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.setInicioJornada, body)
      .pipe(map((response: DefaultResponse) => response));
  }

  public registraFimJornada(body: FimJornada): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.setFimJornada, body)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setAjustarJornada(body: AjustarJornada): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.setAjustarJornada, body)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setInserirJornadaAnterior(body: JornadaPsicologosInserir): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.setInserirJornadaAnterior, body)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setInserirJornadaAnteriorCoordenador(body: JornadaPsicologosInserir): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.setInserirJornadaAnteriorCoordenador, body)
      .pipe(map((response: DefaultResponse) => response));
  }
  public setUpdateJornadaCoordenador(body: UpdateJornadaCoordenador): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.setUpdateJornadaCoordenadorPsicologo, body)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getJornadaEmAberto(cpf: string): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.Psicologo.Jornada.getJornadaEmAberto, { params: { cpf: this.normalizarCpf(cpf) ?? '' } })
      .pipe(map((response: DefaultResponse) => response));
  }

  public getJornadas(codigoPolo: number, codigoDiretoria?: number, codigoEscola?: number | null, cpf?: string | null, dataInicio?: Date | null, dataFim?: Date | null, tempoRegistro?: boolean | null, psicologosInativos?: boolean | null): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Psicologo.Jornada.getJornadas}`, {
      codigoPolo,
      codigoDiretoria,
      codigoEscola,
      cpf: this.normalizarCpf(cpf),
      dataInicio,
      dataFim,
      tempoRegistro,
      psicologosInativos
    }).pipe(map((response: DefaultResponse) => response));
  }

  public getJornadasCoordenadores(codigoPolo: number, codigoDiretoria?: number, codigoEscola?: number | null, cpf?: string | null, dataInicio?: Date | null, dataFim?: Date | null, tempoRegistro?: boolean | null, psicologosInativos?: boolean | null): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Psicologo.Jornada.getJornadasCoordenadores}`, {
      codigoPolo,
      codigoDiretoria,
      codigoEscola,
      cpf: this.normalizarCpf(cpf),
      dataInicio,
      dataFim,
      tempoRegistro,
      psicologosInativos
    }).pipe(map((response: DefaultResponse) => response));
  }

  public getJornadaAtividades(codigoJornada: number): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Psicologo.Jornada.getJornadaAtividades}`, {
      codigoJornada
    }).pipe(map((response: DefaultResponse) => response));
  }

  public getJornadasPorPsicologo(cpf: string): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.Psicologo.Jornada.getJornadasPorPsicologo, { params: { cpf: cpf } })
      .pipe(map((response: DefaultResponse) => response));
  }

  public getJornadaAtualPorPsicologo(cpf: string): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.Psicologo.Jornada.getJornadaAtualPorPsicologo, { params: { cpf: cpf } })
      .pipe(map((response: DefaultResponse) => response));
  }

  public getRegistrosAbertosPsicologo(codigoPsicologo: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.Psicologo.getRegistrosAbertosPsicologo}?codigoPsicologo=${codigoPsicologo}`)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getChamadosAguardandoRegistroPrevencao(codigoEscola: number, codigoDiretoria: number, codigoPsicologo: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.Psicologo.getChamadosAguardandoRegistroPrevencao, {
      params: { codigoEscola: codigoEscola, codigoDiretoria: codigoDiretoria, codigoPsicologo: codigoPsicologo }
    })
      .pipe(map((response: DefaultResponse) => response));
  }

  public getUltimaJornadaFinalizada(cpf: string): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.Psicologo.Jornada.getUltimaJornadaFinalizada, {
      params: { cpf: cpf }
    })
      .pipe(map((response: DefaultResponse) => response));
  }

  public getJornadasDeslocamentos(cpf: string): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.Psicologo.Jornada.getJornadasDeslocamentos, { params: { cpf: cpf } })
      .pipe(map((response: DefaultResponse) => response));
  }

  public getJornadaPorId(id: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.Psicologo.Jornada.getJornadaPorId, { params: { id } })
      .pipe(map((response: DefaultResponse) => response));
  }
  public getEnvolvidosPrevencaoPorCodigoAgendamento(codigoAgendamentoPrevencao: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.Psicologo.Jornada.getEnvolvidosPrevencao, { params: { codigoAgendamentoPrevencao } })
      .pipe(map((response: DefaultResponse) => response));
  }

  public setExcluirAtividade(AtividadeId: number, codigoUsuario: number, nomeUsuario: string): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Psicologo.Jornada.setExcluirAtividade}`, {
      AtividadeId,
      codigoUsuario,
      nomeUsuario
    })
      .pipe(map((response: DefaultResponse) => response));
  }
  public setEnviarParaAprovacaoAtividades(AtividadesId: number[], codigoUsuario: number, nomeUsuario: string, jornadaId?: number): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.setEnviarParaAprovacaoAtividades, { AtividadesId, codigoUsuario, nomeUsuario, jornadaId })
      .pipe(map((response: DefaultResponse) => response));
  }
  public getAtividadePorId(id: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.Psicologo.Jornada.getAtividadePorId}?id=${id}`)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getAtividadePorIdJornada(id: number): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.getAtividadePorIdJornada, { id })
      .pipe(map((response: DefaultResponse) => response));
  }

  public setCadastrarAtividadePsicologoJornada(body: RegistroAtividadePsicologoCheckOut): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.setCadastrarAtividadePsicologoJornada, body)
      .pipe(map((response: DefaultResponse) => response));
  }

  public aprovaReprovaAjustePonto(body: any): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.aprovaReprovaAjustePonto, body)
      .pipe(map((response: DefaultResponse) => response));
  }
  public setAtualizarAtividade(body: EditarJornadaAtividade): Observable<DefaultResponse> {
    return this.http.put<DefaultResponse>(this.api.Psicologo.Jornada.setAtualizarAtividade, body)
      .pipe(map((response: DefaultResponse) => response));
  }
  public setAvaliarAtividade(body: unknown): Observable<DefaultResponse> {
    return this.http.put<DefaultResponse>(this.api.Psicologo.Jornada.setAvaliarAtividade, body)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setInserirJustificativaCheckinout(body: JornadaJustificativaEntradaSaida): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.setInserirJustificativaCheckinout, body)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setInserirJustificativaTempoRegistro(body: JornadaJustificativaTempoRegistro): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.setInserirJustificativaTempoRegistro, body)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setInserirJustificativaDistancia(body: JornadaJustificativaDistancia): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.setInserirJustificativaDistancia, body)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setExcluirJornadaAtividade(atividadeId: number): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.setExcluirJornadaAtividade, { atividadeId })
      .pipe(map((response: DefaultResponse) => response));
  }

  public setExcluirJornada(jornadaId: number): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.setExcluirJornada, { jornadaId })
      .pipe(map((response: DefaultResponse) => response));
  }

  public setAtualizaJustificativaAvaliacao(body: unknown): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.setAtualizaJustificativaAvaliacao, body)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getRelatorioPEC(parametros: Atividade): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.getRelatorioPEC, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getJornadaFinalizadaOutroDia(body: FinalizaJornadaOutroDia): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.getJornadaFinalizadaOutroDia, body)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setCadastrarAtividadePsicologoJornadaMultiEnvolvido(body: RegistroAtividadePsicologoCheckOut): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.Psicologo.Jornada.SetCadastrarAtividadePsicologoJornadaMultiEnvolvido, body)
      .pipe(map((response: DefaultResponse) => response));
  }

}
